<div class="filters-wrapper">
  <div class="daterange-pickers-wrapper">
    <app-dropdown-select
      data-at-hems-filter-kind
      [options]="filters"
      [defaultValue]="defaultFilter"
      (valueSelected)="changeFilter($event)"
    ></app-dropdown-select>

    <ng-container
      *ngrxLet="analyticsStore.selectEarlierstDateFeatureForHemsAnalysisTab$ as earliestDate"
    >
      <div
        *ngIf="featureService.selectGatewayProperties() | async as properties"
        data-at-energy-history-datepickers-wrapper
        class="filter-options-wrapper"
      >
        <ng-container [ngSwitch]="getActiveFilter()">
          <app-day-datepicker
            *ngSwitchCase="FilterType.Day"
            gtm="onSelect"
            gtmAction="Select Day"
            gtmCategory="hems"
            [minDate]="earliestDate || properties.registeredAt"
            (dateChanged)="changeDate($event)"
          >
          </app-day-datepicker>

          <app-month-datepicker
            *ngSwitchCase="FilterType.Month"
            gtm="onSelect"
            gtmAction="Select Month"
            gtmCategory="hems"
            [minDate]="earliestDate || properties.registeredAt"
            (dateChanged)="changeDate($event)"
          >
          </app-month-datepicker>

          <app-year-datepicker
            *ngSwitchCase="FilterType.Year"
            gtm="onSelect"
            gtmAction="Select Year"
            gtmCategory="hems"
            [minDate]="earliestDate || properties.registeredAt"
            (dateChanged)="changeDate($event)"
          >
          </app-year-datepicker>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <button
    data-at-hems-edit-parameters
    (click)="toggleParametersPopup()"
    mat-stroked-button
    class="edit-btn"
    color="primary"
  >
    <mat-icon>edit</mat-icon>
    <span>{{ '+INSTALLATIONS.INSTALLATION.HEMS.EDIT_PARAMETERS' | translate }}</span>
  </button>

  <app-chart-parameters-popup
    class="parameters-popup"
    *ngIf="parametersPopupVisible"
    [isThermalFlow]="isThermalFlow"
    (popupClosed)="toggleParametersPopup()"
  ></app-chart-parameters-popup>
</div>
